import { FC, PropsWithChildren, useState } from 'react';
import cn from 'classnames';
import { ReactComponent as ChevronIcon } from 'images/newIcons/chevron.svg';

interface UncontrolledDropdownSectionProps {
  isOpen?: never;
  onOpenToggle?: never;
}

interface ControlledDropdownSectionProps {
  isOpen: boolean;
  onOpenToggle: (isOpen: boolean) => void;
}

interface CommonDropdownSectionProps {
  title?: string;
  chevronOrientation?: 'vertical' | 'horizontal';
  defaultExpanded?: boolean;
  classNames?: {
    container?: string;
    title?: string;
    chevron?: string;
    content?: string;
  };
}

type DropdownSectionProps = PropsWithChildren<
  (UncontrolledDropdownSectionProps | ControlledDropdownSectionProps) &
    CommonDropdownSectionProps
>;

export const DropdownSection: FC<DropdownSectionProps> = ({
  title,
  isOpen: isOpenOutter,
  chevronOrientation = 'vertical',
  defaultExpanded = true,
  classNames,
  children,
  onOpenToggle: onOpenOutterToggle,
}) => {
  const [isOpenInner, setIsOpenInner] = useState(defaultExpanded);
  const isOpenControlled = isOpenOutter !== undefined;
  const isOpen = isOpenControlled ? isOpenOutter : isOpenInner;

  const handleOpenInnerToggle = () => setIsOpenInner(!isOpenInner);
  const handleOpenToggle = () =>
    isOpenControlled
      ? onOpenOutterToggle?.(!isOpenOutter)
      : handleOpenInnerToggle();

  return (
    <div
      className={cn(
        'flex flex-col items-start gap-2 self-stretch',
        classNames?.container
      )}
    >
      {title && (
        <div className={cn(classNames?.title ?? 'tpg-b2 text-tpg_title')}>
          <div
            className="flex items-center gap-1 cursor-pointer"
            onClick={handleOpenToggle}
          >
            <ChevronIcon
              className={cn(
                isOpen
                  ? chevronOrientation === 'vertical' && 'rotate-180'
                  : chevronOrientation === 'horizontal' && '-rotate-90',
                classNames?.chevron
              )}
            />
            <div className="select-none">{title}</div>
          </div>
        </div>
      )}
      {isOpen && children && (
        <div className={cn('w-full h-full', classNames?.content)}>
          {children}
        </div>
      )}
    </div>
  );
};
